// 引入需要的库和组件
import { Tooltip } from 'antd'
import React, { useRef, useState, useEffect } from 'react'

// 定义组件的属性类型
interface EllipsisTooltipProps {
  title: string | React.ReactNode // 需要显示的文本
  lines?: number // 最多显示的行数，默认为1
  content?: React.ReactNode // 自定义Tooltip的内容
  className?: string // 自定义类名
}

// 定义组件
const Ellipsis: React.FC<EllipsisTooltipProps> = ({ title, lines = 1, content, className }) => {
  // 定义一个状态，用于记录文本是否被截断
  const [isTruncated, setIsTruncated] = useState(false)
  // 定义一个引用，用于获取文本容器的DOM元素
  const containerRef = useRef<HTMLDivElement>(null)

  // 使用useEffect钩子，在组件挂载后和更新后检测文本是否被截断
  useEffect(() => {
    const container = containerRef.current // 获取文本容器的DOM元素
    let isTruncated = false
    if (container) {
      setTimeout(() => {
        const { scrollHeight, clientHeight, offsetWidth, scrollWidth } = container // 获取容器的滚动高度和客户端高度
        if (lines > 1) {
          isTruncated = scrollHeight > clientHeight // 如果 lines 大于 1，检查滚动高度是否大于客户端高度
        } else {
          isTruncated = scrollWidth > offsetWidth // 如果 lines 等于 1，检查滚动宽度是否大于客户端宽度
        }
        setIsTruncated(isTruncated)
      }, 0)
    }
  }, [title, lines]) // 添加title和lines到依赖数组

  // 返回组件的JSX
  return (
    // 使用Tooltip组件，如果文本被截断，就显示完整文本，否则不显示
    <Tooltip title={isTruncated ? content || title : ''}>
      <div
        ref={containerRef} // 设置引用
        style={{
          overflow: 'hidden', // 隐藏超出容器的文本
          textOverflow: 'ellipsis', // 文本超出时显示省略号
          display: lines > 1 ? '-webkit-box' : 'block', // 如果 lines 大于 1，使用 -webkit-box 布局，否则使用 block 布局
          WebkitBoxOrient: 'vertical', // 垂直布局
          WebkitLineClamp: lines, // 限制行数
          whiteSpace: lines > 1 ? 'normal' : 'nowrap', // 如果 lines 大于 1，文本可以换行，否则不换行
        }}
        className={className} // 设置自定义类名
      >
        {title} {/**显示文本 */}
      </div>
    </Tooltip>
  )
}

// 导出组件
export default Ellipsis
